import PropTypes from 'prop-types';

import PredictiveSearchBar from './PredictiveSearchBar';
import RecipeFilters from '../RecipeFilter/RecipeFilters';
import SearchTypeMenu from '../Search/SearchTypeMenu';
import SearchTitle from '../Search/SearchTitle';

import { SEARCH_TYPE_DATA } from '../Search/SearchTypeData';

import { noop } from '../../utils/utility';

/**
 * @summary Renders the Predictive Search Header.
 * This is meant for the Search Page; if you want to render the search form somewhere else,
 * use `PredictiveSearchBar` or `PredictiveSearchForm`.
 * @param {import('./PredictiveSearchHeaderProps').PredictiveSearchHeaderProps} props
 * @returns {JSX.Element}
 */
export default function PredictiveSearchHeader({
	found = 0,
	onSearch = noop,
	term = '',
	termPosition = '',
	filters = [],
	filterItems = {},
	filtersData = {},
	postFilter = {},
	setFilters = noop,
	setPostFilter = noop,
	isValidating = false,
	redirect = false,
	searchInputLabelId,
	searchId,
}) {
	// Adobe analytics data
	const adobeAnalyticsData = {
		searchTerm: term,
		searchResults: found,
		searchPosition: termPosition,
	};

	return (
		<div className="search-header">
			<div className="search-bar-container">
				<PredictiveSearchBar
					isCompact
					shouldRedirectOnSubmit={redirect}
					initialValue={term}
					onSearch={onSearch}
					searchPlaceholder="Search"
					shouldFocus={redirect}
					searchInputLabelId={searchInputLabelId}
					searchInputId={searchId}
					submitButtonLabel="GO"
				/>
			</div>
			{!redirect && (
				<div className="search-controls" data-search-input={JSON.stringify(adobeAnalyticsData, null, 2)}>
					{term && (
						<RecipeFilters
							filters={filters}
							setFilters={setFilters}
							filterItems={filterItems}
							filtersData={filtersData}
						/>
					)}
					{term && !isValidating && <SearchTitle found={found} term={term} />}
					{term && isValidating && <SearchTitle found=".." term={term} />}
					{term && <SearchTypeMenu items={SEARCH_TYPE_DATA} onChange={setPostFilter} initialSelected={postFilter} />}
				</div>
			)}
		</div>
	);
}

PredictiveSearchHeader.propTypes = {
	searchInputLabelId: PropTypes.string.isRequired,
	searchId: PropTypes.string.isRequired,
	found: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	onSearch: PropTypes.func,
	term: PropTypes.string,
	termPosition: PropTypes.string,
	filters: PropTypes.array,
	filterItems: PropTypes.object,
	filtersData: PropTypes.object,
	redirect: PropTypes.bool,
	postFilter: PropTypes.object,
	setFilters: PropTypes.func,
	setPostFilter: PropTypes.func,
	isValidating: PropTypes.bool,
};
